import { buildProps, definePropType } from '@ll-plus/utils'

// import type { ExtractPropTypes } from 'vue'

export const jsonTableColumns = [
  {
    title: '字段名',
    key: 'name',
    dataIndex: 'name',
    span: 6
  },
  {
    title: '类型',
    key: 'type',
    dataIndex: 'type',
    span: 4
  },
  {
    title: 'Mock',
    key: 'mock',
    dataIndex: 'mock',
    span: 4
  },
  {
    title: '中文名',
    key: 'chineseName',
    dataIndex: 'chineseName',
    span: 4
  },
  {
    title: '说明',
    key: 'description',
    dataIndex: 'description',
    span: 6
  }
]

export const jsonXmlOptions = [
  {
    value: 'json',
    payload: {
      title: '参数值'
    }
  },
  {
    value: 'data',
    payload: {
      title: '数据结构'
    }
  }
]

export const DEFAULT_TYPE = 'data'

export const customOverlay = [
  {
    label: '仅生成字段名'
  },
  {
    label: '优先使用字段默认值'
  },
  {
    label: '优先使用字段示例值'
  }
]

export const jsonXmlTypeOptions = [
  {
    label: 'string',
    value: 'string'
  },
  {
    label: 'interger',
    value: 'interger'
  },
  {
    label: 'boolean',
    value: 'boolean'
  },
  {
    label: 'array',
    value: 'array'
  },
  {
    label: 'object',
    value: 'object'
  },
  {
    label: 'number',
    value: 'number'
  },
  {
    label: 'null',
    value: 'null'
  },
  {
    label: 'any',
    value: 'any'
  },
  {
    label: '自定义',
    value: 'other'
  }
]

export type IType =
  | 'string'
  | 'interger'
  | 'boolean'
  | 'array'
  | 'object'
  | 'number'
  | 'null'
  | 'any'
  | 'other'

export interface IJsonXmlItem {
  name?: string
  type?: IType
  value?: any
  mock?: string
  chineseName?: string
  description?: string
  children?: IJsonXmlItem[]
  [key: string]: any
}

export const jsonXmlProps = buildProps({
  value: {
    type: Object,
    default: () => {}
  },
  type: {
    type: definePropType<'xml' | 'json'>(String),
    default: 'json'
  }
} as const)

export const jsonXmlEmits = {
  'update:value': (value: any) => !!value
}

export const jsonXmlTableProps = buildProps({
  dataSource: {
    type: definePropType<IJsonXmlItem[]>(Array),
    default: () => []
  },
  type: {
    type: definePropType<'xml' | 'json'>(String)
  }
} as const)

export const jsonXmlTableEmits = {
  change: (value: any) => !!value
}

export const jsonXmlTableRowProps = buildProps({
  data: {
    type: definePropType<IJsonXmlItem>(Object),
    default: () => {}
  },
  list: {
    type: definePropType<IJsonXmlItem[]>(Array),
    default: () => []
  },
  parentData: {
    type: definePropType<IJsonXmlItem>(Object),
    default: () => null
  },
  layer: {
    type: Number,
    default: 0
  },
  treeKey: {
    type: String,
    default: ''
  }
} as const)

export const jsonXmlTableRowEmits = {
  change: (val: IJsonXmlItem) => !!val
}
